export const DashSeparator = () => (
  <div className="separator separator-dashed my-6"></div>
)
